import React, { useEffect, useState } from "react";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import { Loader } from "@progress/kendo-react-indicators";
import { ReportURL } from "api/axios.config";
import { useUploadForm } from "components/fileUploadHook";
import { toast } from "react-toastify";
import { handleDownloadAndUpload } from "components/common/HandleReportDownload";

const ReportViewer = (props) => {
    let viewer;
    const { accessToken } = useOidcAccessToken();
    const [isLoading, setIsLoading] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const { uploadForm } = useUploadForm();

    const exportToPDF = () => {
        if (viewer) {
            viewer.commands.export.exec("PDF");
        }
    };

    useEffect(() => {
        if (props.exportFunction) {
            exportToPDF();
        }
    }, [props.exportFunction]);

    const handleExportEnd = async (e, args) => {                

        if (props.saveActivityRef?.current) {
            args.handled = true;

            const modifiedUrl = replaceDisposition(args.url);

            await handleDownloadAndUpload(
                modifiedUrl,
                props.matterID,
                uploadForm, 
                () => {
                    toast.success("Activity Added");                    
                },
            );            
        }

        props.saveActivityRef.current = false;
        props.exportCallback?.();

    };

    function replaceDisposition(url) {
        return url.replace("attachment", "inline");
    }

    useEffect(() => {
        const handleWindowResize = () => {
            if (window.innerWidth > 1400 && windowWidth < 1400) {
                viewer.refreshReport();
                setWindowWidth(window.innerWidth);
            } else if (window.innerWidth < 1400 && windowWidth > 1400) {
                viewer.refreshReport();
                setWindowWidth(window.innerWidth);
            }
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    });

    useEffect(() => {
        if (props.shouldLoad) {
            setIsLoading(true);
            viewer.setReportSource({
                report: props.name,
                parameters: {
                    ...props.parameters,
                },
            });
            props.setShouldLoad(false);
            setTimeout(() => {
                setIsLoading(false);
            }, 2000);
        }
    }, [props.shouldLoad]);

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            {isLoading && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000
                    }}
                >
                    <Loader
                        themeColor="warning"
                        size="large"
                        type="pulsing"
                    />
                </div>
            )}
            <TelerikReportViewer
                ref={(el) => (viewer = el)}
                serviceUrl={props.url ? props.url : `${ReportURL}/Reporting/reports/`}
                pageReady={() => {
                    setIsLoading(false);
                }}
                disabledButtonClass="checkedClass"
                authenticationToken={accessToken}
                exportEnd={handleExportEnd}
                viewerContainerStyle={{
                    height: props?.modalHeight ? props?.modalHeight : "82vh",
                    windowWidth: "100%",
                    clear: "both",
                    fontFamily: "ms sans serif",
                }}
                reportSource={{
                    report: props.name,
                    parameters: {
                        ...props.parameters,
                    },
                }}
                viewMode="INTERACTIVE"
                scaleMode="SPECIFIC"
                scale={1}
                enableAccessibility={false}
                error={(e) => {
                    setIsLoading(false);
                }}
            />
        </div>
    );
};

export default ReportViewer;
